import React from "react";

const PettyCashUsersModal = (props) => {
    const { selectedPettyCashUsers } = props;

    return (
        <div className='req-details-modal mb-2 py-2'>
            <div className="custom-table-container">
                <table className="custom-product-table" style={{ width: "100%" }}>
                    <thead>
                        <tr className="">
                            <th className="">SR</th>
                            <th className="">User Name</th>
                            <th className="">User Email</th>
                        </tr>
                    </thead>
                    <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                        {selectedPettyCashUsers.map((user, index) => (
                            <tr className="" key={index}>
                                <td className="">{index + 1}</td>
                                <td className="">{user?.userName}</td>
                                <td className="">{user?.email}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default PettyCashUsersModal;
